<template>
  <div>
    <q-card class="my-card">
      <q-card-section>
        <div class="row">
          <div class="col-7">
            <div class="title">Ámbitos</div>
            <div class="subtitle">
              {{ arrayAmbito.name }} pertence a los siguientes Ámbitos:
            </div>
          </div>
          <div class="col-5">
            <div style="text-align: right">
              <q-select
                data-cy="select-ambitos"
                hide-selected
                multiple
                outlined
                v-model="ambitoArray"
                :options="dataAmbitos"
                option-value="id"
                option-label="name"
                label="Añadir al Ámbito"
              >
                <template
                  v-slot:option="{
                    itemProps,
                    itemEvents,
                    opt,
                    selected,
                    toggleOption,
                  }"
                >
                  <q-item
                    v-bind="itemProps"
                    v-on="itemEvents"
                    active-class="multiple-select-active"
                  >
                    <q-item-section :side="true">
                      <q-checkbox
                        :value="selected"
                        @input="toggleOption(opt)"
                      />
                    </q-item-section>
                    <q-item-section no-wrap class="ellipsis multiple-select">
                      <q-item-label>{{ opt.name }} </q-item-label>
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
          </div>
        </div>
        <div class="row">
          <q-chip
            removable
            @remove="removeElement(item)"
            text-color="black"
            outline
            v-for="item in ambitoArray"
            :key="item.id"
          >
            {{ item.name }}
          </q-chip>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Formats from '@/components/shared/mixins/Formats.js';

export default {
  components: {},
  mixins: [Message, Validation, Formats],
  props: {
    dataVertical: Object,
    arrayAmbitos: Array,
    isNew: Boolean
  },
  mounted () {
    this.$eventHub.$on('EJECUCION_GUARDAR_AMBITOS', ({ callback, rejected }) =>
      this.setAmbitoApp(callback, rejected)
    );
  },
  beforeDestroy () {
    this.$eventHub.$off('EJECUCION_GUARDAR_AMBITOS');
  },
  methods: {
    removeElement (element) {
      var idx = this.ambitoArray.indexOf(element);
      this.ambitoArray.splice(idx, 1);
    },
    async setAmbitoApp (callback) {
      let ambitos = this.ambitoArray.map((n) => n.id);

      let dataArray = ambitos;

      let request = {
        controller: '/Vertical/' + this.dataVertical.id + '/ambitos-relationship',
        filter: {},
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/postSuit', request)
        .then((response) => {
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err);

          responseData = {
            data: null,
            status: false
          };
        });

      callback(responseData);
    },
    _setSelectAmbitos (ambitos) {
      let data = [];
      this.dataAmbitos.forEach(elem => {
        ambitos.forEach(i => {
          if (elem.id === i) {
            data.push(elem);
          }
        });
      });

      return data;
    }
  },
  data () {
    return {
      arrayAmbito: this.dataVertical,
      ambitoArray: [],
      dataAmbitos: this.arrayAmbitos
    };
  },
  watch: {
    dataVertical: {
      handler: function () {
        this.arrayAmbito = this.dataVertical;

        if (Object.entries(this.dataVertical).length > 0) {
          this.ambitoArray = this.arrayAmbito.ambitos;
        }
      },
      immediate: true
    },
    arrayAmbitos: {
      handler: function () {
        // Replace object to return null icon
        this.dataAmbitos = this.arrayAmbitos.map((n) => ({
          id: n.id,
          name: n.name,
          visible: n.visible
        }));

        if (Object.entries(this.dataVertical).length > 0) {
          this.ambitoArray = this._setSelectAmbitos(this.ambitoArray);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-app {
  .input-row {
    padding: 16px 0px;
  }
  /* Desplaza el contador de caracteres a la izquierda */
  &:deep() {
    .q-field__messages {
      display: contents;
    }
    .q-field__counter {
      padding-left: 4px;
    }
  }
}

.container-images {
  padding-left: 18px;
}
</style>
